export default function (a, b) {
    var d = new Date;
    return a = +a, b = +b, function (t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}
